/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreBulkOperationDto } from '../../models/core-bulk-operation-dto';
import { CoreBulkOperationResultDto } from '../../models/core-bulk-operation-result-dto';

export interface ProjectSubtasksControllerBulkOperation$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
  
    /**
     * Bulk operation data (subtaskIds, operation, userId)
     */
    body: CoreBulkOperationDto
}

export function projectSubtasksControllerBulkOperation(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerBulkOperation$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreBulkOperationResultDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerBulkOperation.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreBulkOperationResultDto>;
    })
  );
}

projectSubtasksControllerBulkOperation.PATH = '/o2-core/project-subtasks/{tenant}/operations/bulk';
